<div [ngClass]="{'d-none': !hasNavbar}">
  <div class="row d-flex align-items-center justify-content-between">
    <div class="col-auto">
      <span *ngIf="authService.user" class="h1 fw-light">
        Welcome Back <span class="d-none d-md-inline">{{ authService.user.given_name }}</span>
      </span>
    </div>
    <div class="col-12 col-md-6 col-xl-3">
      <dx-go-to-input [dark]="true"></dx-go-to-input>
    </div>
  </div>
  <div class="dx-nav d-flex flex-row">
    <a *ngFor="let link of authService.appConfig.navbarLinks"
      class="d-flex flex-column align-items-center justify-content-center text-center active" [routerLink]="link.url">
      <fa-layers [fixedWidth]="true">
        <fa-icon [icon]="['fas', 'circle']"></fa-icon>
        <fa-icon [icon]="getLinkIcon(link.icon)" transform="shrink-8"></fa-icon>
      </fa-layers>
      <b class="mt-4">{{ link.name }}</b>
    </a>
  </div>
</div>
